import React, { useEffect, useState, useMemo } from 'react'
import Select from "react-select";
import { useSelector } from 'react-redux';
import moment from 'moment/moment';
import DatePicker from "react-datepicker";
import { FaDownload } from "react-icons/fa";
import Layout from "../../layout";
import services from 'API/services';
import { mainUrl } from 'API/client/api';
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import axios from 'axios';

const TaLedgerReport = () => {

  const [taUsers, setTaUsers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  const { userDetail, access_token } = useSelector(authenticationSeletor);

  const fetchTaUsers = async (value) => {
    try {
      let param = `?${value ? `search=${value}&` : ''}limit=10`;
      const res = await services.property.taUsersService(param)
      if (res.status === 200) {
        setTaUsers(res?.data?.data)
      }
    }
    catch (err) { console.log(err) }
  }

  useEffect(() => {
    fetchTaUsers()
  }, [])

  const handleInputChange = (value) => {
    setInputValue(value);

    if (value.length >= 7) {
      setError("");
      fetchTaUsers(value);
    } else {
      setError("Minimum 7 characters required");
    }
  };

  const options = useMemo(() => {
    return taUsers?.map((item) => ({
      value: item?.taCode,
      label: `${item?.firstName} ${item?.lastName} - ${item?.taCode}`,
    }));
  }, [taUsers]);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const handleDownloadLedger = async () => {
    const fromDate = formatDate(startDate);
    const toDate = formatDate(endDate);
    const res = await fetch(`${mainUrl}api/travel-agent/ta-ledger/export?fromDate=${fromDate}&toDate=${toDate}&taCode=${selected?.value}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${access_token}`
      }
    });
    if (res.ok == true) {
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Ledger-Report-${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
    else {
      // toast.warn("Invalid Booking Code. Please try again!");
    }
  };

  const [getTaLedgerList, setGetLedgerList] = useState([])
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [paymentMode, setPaymentMode] = useState("");
  const [remark, setRemark] = useState("");
  const [showModal, setShowModal] = useState(false);

  const getTaLedgerData = async (taCode) => {
    const res = await axios.get(`${mainUrl}api/travel-agent/get-ta-ledger-data?taCode=${taCode}`, {
      headers: { "Authorization": `Bearer ${access_token}` }
    })
    if (res?.status == 200) { setGetLedgerList(res?.data?.data) }
  }

  useEffect(() => { if (selected?.value) { getTaLedgerData(selected?.value) } }, [selected?.value])

  const openModal = (ledger) => {
    setSelectedLedger(ledger);
    setPaymentMode("");
    setRemark("");
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const handleSubmit = async () => {
    if (!selectedLedger) return;
    try {
      const res = await axios.put(`${mainUrl}api/travel-agent/ta-payment-update`, { id: selectedLedger.id, paymentMode, remark, status: 2 }, { headers: { "Authorization": `Bearer ${access_token}` } });
      if (res?.data?.status == true) {
        closeModal();
        getTaLedgerData(selected?.value)
      }
    } catch (error) { console.error("Error updating ledger:", error) }
  };


  return (
    <Layout
      searchType={false}>
      <div>
        <h3>Download TA Ledger</h3>
      </div>
      <div className='row justify-content-center'>
        <div className='col-lg-3'>
          <Select
            options={options}
            value={selected}
            onChange={(value) => setSelected(value)}
            placeholder="Select TA User"
            onInputChange={(value) => handleInputChange(value)}
            inputValue={inputValue}
          />
          {
            !selected && <p className='fs-8 text-danger'>Please select a Travel Agent to download Ledger Report</p>
          }
        </div>
      </div>
      <div style={{ background: "#fff", border: "1px solid #e5e5e5", padding: "20px", borderRadius: "10px", marginBottom: "10px", marginTop: "10px" }}>
        <div className="row" style={{ display: "flex", alignItems: "end", gap: "15px", flexWrap: "wrap", justifyContent: "center" }}>
          <div style={{ width: "250px" }}>
            <label style={{ fontWeight: 600, fontSize: "14px", color: "#333", marginBottom: "5px", display: "block" }}>
              Start Date
            </label>
            <DatePicker
              className="form-control"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd-MM-yyyy"
              style={{
                width: "100%",
                padding: "10px 12px",
                height: "40px",
                borderRadius: "8px",
                fontSize: "14px"
              }}
            />
          </div>
          <div style={{ width: "250px" }}>
            <label style={{ fontWeight: 600, fontSize: "14px", color: "#333", marginBottom: "5px", display: "block" }}>End Date</label>
            <DatePicker
              className="form-control"
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="dd-MM-yyyy"
              style={{
                width: "100%",
                padding: "10px 12px",
                height: "40px",
                borderRadius: "8px",
                fontSize: "14px"
              }}
            />
          </div>
          <div style={{ width: "250px" }}>
            <label style={{ display: "block", marginBottom: "5px", visibility: "hidden" }}>Download</label>
            <button
              type="button"
              disabled={!selected}
              onClick={handleDownloadLedger}
              style={{
                width: "100%",
                height: "40px",
                borderRadius: "8px",
                fontWeight: 600,
                background: "#333",
                color: "#fff",
                border: "none",
                cursor: selected ? "pointer" : "not-allowed",
                opacity: selected ? 1 : 0.6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px"
              }}
            >
              <FaDownload size={16} /> Download Ledger
            </button>
          </div>
        </div>

        <div style={{ marginTop: "20px", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>TA Code</th>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Booking Code</th>
                <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "center" }}>No of Rooms | Nights</th>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Booking Amount</th>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>TA Commission</th>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Total Commission</th>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Payment Mode</th>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Status</th>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {getTaLedgerList.map((item) => (
                <tr key={item.id} style={{ borderBottom: "1px solid #eee" }}>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.taCode}</td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.booking.bookingCode}</td>
                  <td style={{ padding: "10px", border: "1px solid #ddd", textAlign: "center" }}>
                    {item.noOfRooms} | {Math.max(1, Math.ceil((new Date(item.booking.toDate) - new Date(item.booking.fromDate)) / (1000 * 60 * 60 * 24))
                    )}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.bookingAmount}</td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {item.booking.taCommissionPerc ? `${item.booking.taCommissionPerc}%/Booking Amount` : item.booking.taCommissionPerRoom ? `${item.booking.taCommissionPerRoom}/Room` : "-"}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.totalCommisssion}</td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.paymentMode ?? "-"}</td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.status == 1 ? "Unpaid" : "Paid"}</td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    <button className="btn btn-primary btn-sm" disabled={item.status == 2} onClick={() => openModal(item)}>Mark As Paid</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {showModal && (
            <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
              <div style={{ background: "#fff", padding: "20px", borderRadius: "8px", width: "400px" }}>
                <h3 style={{ marginBottom: "15px" }}>Mark as Paid</h3>
                <div style={{ marginBottom: "15px" }}>
                  <label>Payment Mode</label>
                  <select value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)} style={{ width: "100%", padding: "8px", marginTop: "5px" }}>
                    <option value="">Select Method</option>
                    <option value="CASH">CASH</option>
                    <option value="UPI">UPI</option>
                    <option value="BANK">BANK</option>
                  </select>
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label>Remark</label>
                  <textarea value={remark} onChange={(e) => setRemark(e.target.value)} style={{ width: "100%", padding: "8px", marginTop: "5px", resize: "none" }} />
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                  <button onClick={closeModal} style={{ padding: "8px 12px" }}>Cancel</button>
                  <button onClick={handleSubmit} disabled={!paymentMode} style={{ padding: "8px 12px", background: "#333", color: "#fff" }}>Submit</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

    </Layout>
  )
}

export default TaLedgerReport